export default {
  webinar: {
    rightColumnTabs: (intl) => ({
      tabHeaders: {
        info: {
          label: intl.formatMessage({
            description: 'tab header info',
            defaultMessage: 'Info',
          }),
        },
        qa: {
          label: intl.formatMessage({
            description: 'tab header qa',
            defaultMessage: 'Q&A',
          }),
        },
        social: {
          label: intl.formatMessage({
            description: 'tab header social',
            defaultMessage: 'Social',
          }),
        },
      },
      tabs: {
        info: {
          description: {
            label: intl.formatMessage({
              description: 'session info description',
              defaultMessage: 'Description',
            }),
          },
          speakers: {
            label: intl.formatMessage({
              description: 'session info speakers',
              defaultMessage: 'Speakers',
            }),
          },
        },
        qa: {
          questions: {
            label: intl.formatMessage({
              description: 'qa questions',
              defaultMessage: 'Questions',
            }),
          },
          question: {
            mine: {
              label: intl.formatMessage({
                description: 'qa question mine',
                defaultMessage: 'You',
              }),
            },
          },
        },
        social: {
          messages: {
            youTranslation: intl.formatMessage({
              description: '"you" label on message',
              defaultMessage: 'You',
            }),
          },
          serviceMessages: {
            webinarJoin: {
              label: intl.formatMessage({
                description: 'social service message join',
                defaultMessage: 'joined the webinar',
              }),
            },
            webinarLeave: {
              label: intl.formatMessage({
                description: 'social service message leave',
                defaultMessage: 'left the webinar',
              }),
            },
          },
          moderator: {
            deleteMessage: intl.formatMessage({
              description: 'moderator delete message',
              defaultMessage: 'Message is inappropriate',
            }),
            buttons: {
              ban: intl.formatMessage({
                description: 'moderator ban button',
                defaultMessage: 'Ban User',
              }),
              bannedUser: intl.formatMessage({
                description: 'moderator banned button',
                defaultMessage: 'User blocked',
              }),
              delete: intl.formatMessage({
                description: 'moderator delete button',
                defaultMessage: 'Delete Message',
              }),
              moderated: intl.formatMessage({
                description: 'moderated tooltip text',
                defaultMessage: 'Moderated',
              }),
            },
          },
          bannedError: intl.formatMessage({
            description: 'banned error placeholder',
            defaultMessage: 'Chat disabled for your user',
          }),
          messageInput: {
            placeholder: intl.formatMessage({
              description: 'chat input placeholder',
              defaultMessage: 'Write your message here...',
            }),
            emojiPicker: {
              title: intl.formatMessage({
                description: 'emoji picker title',
                defaultMessage: 'Pick your emoji...',
              }),
              i18n: {
                search: intl.formatMessage({
                  description: 'emoji picker search',
                  defaultMessage: 'Search',
                }),
                clear: intl.formatMessage({
                  description: 'emoji picker clear',
                  defaultMessage: 'Clear',
                }),
                notfound: intl.formatMessage({
                  description: 'emoji picker not found',
                  defaultMessage: 'No Emoji Found',
                }),
                skintext: intl.formatMessage({
                  description: 'emoji picker skin text',
                  defaultMessage: 'Choose your default skin tone',
                }),
                categories: {
                  search: intl.formatMessage({
                    description: 'emoji picker categories search',
                    defaultMessage: 'Search Results',
                  }),
                  recent: intl.formatMessage({
                    description: 'emoji picker categories recent',
                    defaultMessage: 'Frequently Used',
                  }),
                  smileys: intl.formatMessage({
                    description: 'emoji picker categories smileys',
                    defaultMessage: 'Smileys & Emotion',
                  }),
                  people: intl.formatMessage({
                    description: 'emoji picker categories people',
                    defaultMessage: 'People & Body',
                  }),
                  nature: intl.formatMessage({
                    description: 'emoji picker categories nature',
                    defaultMessage: 'Animals & Nature',
                  }),
                  foods: intl.formatMessage({
                    description: 'emoji picker categories foods',
                    defaultMessage: 'Food & Drink',
                  }),
                  activity: intl.formatMessage({
                    description: 'emoji picker categories activity',
                    defaultMessage: 'Activity',
                  }),
                  places: intl.formatMessage({
                    description: 'emoji picker categories places',
                    defaultMessage: 'Travel & Places',
                  }),
                  objects: intl.formatMessage({
                    description: 'emoji picker categories objects',
                    defaultMessage: 'Objects',
                  }),
                  symbols: intl.formatMessage({
                    description: 'emoji picker categories symbols',
                    defaultMessage: 'Symbols',
                  }),
                  flags: intl.formatMessage({
                    description: 'emoji picker categories flags',
                    defaultMessage: 'Flags',
                  }),
                  custom: intl.formatMessage({
                    description: 'emoji picker categories custom',
                    defaultMessage: 'Custom',
                  }),
                },
                categorieslabel: intl.formatMessage({
                  description: 'emoji picker categories label',
                  defaultMessage: 'Emoji categories',
                }),
                skintones: {
                  1: intl.formatMessage({
                    description: 'emoji picker default skin tone',
                    defaultMessage: 'Default Skin Tone',
                  }),
                  2: intl.formatMessage({
                    description: 'emoji picker light skin tone',
                    defaultMessage: 'Light Skin Tone',
                  }),
                  3: intl.formatMessage({
                    description: 'emoji picker medium-light skin tone',
                    defaultMessage: 'Medium-Light Skin Tone',
                  }),
                  4: intl.formatMessage({
                    description: 'emoji picker medium skin tone',
                    defaultMessage: 'Medium Skin Tone',
                  }),
                  5: intl.formatMessage({
                    description: 'emoji picker medium-dark skin tone',
                    defaultMessage: 'Medium-Dark Skin Tone',
                  }),
                  6: intl.formatMessage({
                    description: 'emoji picker dark skin tone',
                    defaultMessage: 'Dark Skin Tone',
                  }),
                },
              },
            },
            error: {
              label: intl.formatMessage({
                description: 'chat message input error',
                defaultMessage: 'Error, try again',
              }),
            },
          },
        },
      },
    }),
    surveyDialogContent: (intl) => ({
      buttons: {
        send: {
          label: intl.formatMessage({
            description: 'survey send button',
            defaultMessage: 'Send',
          }),
        },
      },
      alert: {
        noMoreQuestion: {
          label: intl.formatMessage({
            description: 'no more pools',
            defaultMessage: 'No more polls avalaible',
          }),
        },
      },
    }),
    askAQuestionDialog: (intl) => ({
      text: {
        title: {
          label: intl.formatMessage({
            description: 'ask a question title',
            defaultMessage: 'Ask A Question',
          }),
        },
        inputPlaceHolder: intl.formatMessage({
          description: 'ask a question input placeholder',
          defaultMessage: 'Write your question here...',
        }),
        isAnonymousText: {
          label: intl.formatMessage({
            description: 'is anonymous text',
            defaultMessage: 'I want to remain anonymous',
          }),
        },
      },
      buttons: {
        send: {
          label: intl.formatMessage({
            description: 'ask a question send button',
            defaultMessage: 'Send',
          }),
        },
      },
    }),
    endOverlay: (intl) => ({
      firstMessage: {
        label: intl.formatMessage({
          description: 'end overlay first message',
          defaultMessage: 'Session ended. Thanks for participating!',
        }),
      },
      secondMessage: {
        label: intl.formatMessage({
          description: 'end overlay second message',
          defaultMessage: 'Keep watching:',
        }),
      },
      goToSessionsButton: {
        label: intl.formatMessage({
          description: 'end overlay go to session button',
          defaultMessage: 'GO TO ALL SESSIONS',
        }),
      },
    }),
    countdownComponent: (intl) => ({
      title: {
        label: intl.formatMessage({
          description: 'countdown title',
          defaultMessage: 'Event starts in',
        }),
      },
    }),
    pleaseRotate: (intl) => ({
      mainText: {
        label: intl.formatMessage({
          description: 'please rotate main text',
          defaultMessage:
            'Please rotate your device in landscape mode to watch the webinar',
        }),
      },
    }),
  },
  breakoutRoom: {
    breakoutRoomPage: (intl) => ({
      dialog: {
        kicked: {
          title: {
            label: intl.formatMessage({
              description: 'dialog kick title',
              defaultMessage: 'The host got you out of the room',
            }),
          },
          message: {
            label: intl.formatMessage({
              description: 'dialog kick message',
              defaultMessage:
                'The host has temporarily got you out of the room. In this modality, you are not allowed to interact with other participants in the room. Once you have left the room, you might still join again from the appointment in your Agenda.',
            }),
          },
        },
        unpublished: {
          title: {
            label: intl.formatMessage({
              description: 'dialog unpublished title',
              defaultMessage: 'You are now an auditor attendee',
            }),
          },
          message: {
            label: intl.formatMessage({
              description: 'dialog unpublished message',
              defaultMessage:
                'The host has assigned you the role of auditor- only. In this modality, you are allowed to attend the appointment as an auditor-only so screen and audio sharing features are temporarily de-activated. To re-enable these features, you need to leave the room and re-join from your Agenda.',
            }),
          },
        },
        timeExpired: {
          title: {
            label: intl.formatMessage({
              description: 'dialog time expired title',
              defaultMessage: 'Time is up!',
            }),
          },
          message: {
            label: intl.formatMessage({
              description: 'dialog time expired message',
              defaultMessage: 'The meeting time is now expired.',
            }),
          },
        },
        error: {
          title: {
            label: intl.formatMessage({
              description: 'dialog error title',
              defaultMessage: 'Error',
            }),
          },
          message: {
            label: intl.formatMessage({
              description: 'dialog error message',
              defaultMessage: 'Unespected error, try again',
            }),
          },
        },
        buttons: {
          ok: {
            label: intl.formatMessage({
              description: 'dialog close button',
              defaultMessage: 'OK',
            }),
          },
        },
      },
      tabHeaders: {
        info: {
          label: intl.formatMessage({
            description: 'tab header info',
            defaultMessage: 'Info',
          }),
        },
        participants: {
          label: intl.formatMessage({
            description: 'tab header participants',
            defaultMessage: 'Participants',
          }),
        },
        chat: {
          label: intl.formatMessage({
            description: 'tab header chat',
            defaultMessage: 'Chat',
          }),
        },
        settings: {
          label: intl.formatMessage({
            description: 'tab header settings',
            defaultMessage: 'Settings',
          }),
        },
      },
      loader: {
        disconnect: {
          label: intl.formatMessage({
            description: 'loader disconnecting label',
            defaultMessage: 'Disconnecting...',
          }),
        },
      },
    }),
    tabSettings: (intl) => ({
      group: {
        refresh: {
          label: intl.formatMessage({
            description: 'refresh devices tooltip text',
            defaultMessage: 'Refresh devices',
          }),
        },
        microphone: {
          label: intl.formatMessage({
            description: 'tab group microphone',
            defaultMessage: 'Microphone',
          }),
        },
        camera: {
          label: intl.formatMessage({
            description: 'tab group camera',
            defaultMessage: 'Camera',
          }),
        },
        notifications: {
          label: intl.formatMessage({
            description: 'tab group notifications',
            defaultMessage: 'Notifications',
          }),
          playText: {
            label: intl.formatMessage({
              description: 'tab play sound text',
              defaultMessage: 'Play sound when someone joins/leaves',
            }),
          },
        },
      },
    }),
    tabParticipants: (intl) => ({
      page: {
        userActive: {
          label: intl.formatMessage({
            description: 'tab participant user active',
            defaultMessage: 'Active',
          }),
        },
        muteAll: {
          label: intl.formatMessage({
            description: 'tab participant mute all',
            defaultMessage: 'Mute All',
          }),
        },
        disableAllScreenSharing: {
          label: intl.formatMessage({
            description: 'tab participant disable all screen sharing',
            defaultMessage: 'Disable Video Share',
          }),
        },
        tooltips: {
          camera: {
            enable: {
              label: intl.formatMessage({
                description: 'enable camera tooltip text',
                defaultMessage: 'Enable Camera',
              }),
            },
            disable: {
              label: intl.formatMessage({
                description: 'disable camera tooltip text',
                defaultMessage: 'Disable Camera',
              }),
            },
          },
          microphone: {
            enable: {
              label: intl.formatMessage({
                description: 'enable microphone tooltip text',
                defaultMessage: 'Unmute',
              }),
            },
            disable: {
              label: intl.formatMessage({
                description: 'disable microphone tooltip text',
                defaultMessage: 'Mute',
              }),
            },
          },
          videoSharing: {
            enable: {
              label: intl.formatMessage({
                description: 'enable video sharing tooltip text',
                defaultMessage: 'Share Screen',
              }),
            },
            disable: {
              label: intl.formatMessage({
                description: 'disable video sharing tooltip text',
                defaultMessage: 'Stop Sharing',
              }),
            },
          },
          kick: {
            label: intl.formatMessage({
              description: 'kick user tooltip text',
              defaultMessage: 'Kick User',
            }),
          },
          unpublish: {
            label: intl.formatMessage({
              description: 'unpublish user tooltip text',
              defaultMessage: 'Unpublish User',
            }),
          },
        },
      },
    }),
    tabInfo: (intl) => ({
      page: {
        hostedBy: {
          label: intl.formatMessage({
            description: 'tab info hosted by',
            defaultMessage: 'Hosted by',
          }),
        },
      },
    }),
    publisherDraggableControls: (intl) => ({
      you: {
        label: intl.formatMessage({
          description: 'publisher draggable controls you',
          defaultMessage: 'You',
        }),
      },
      presenting: {
        label: intl.formatMessage({
          description: 'publisher draggable presenting',
          defaultMessage: 'You are presenting to all',
        }),
      },
    }),
    social: (intl) => ({
      serviceMessages: {
        brJoin: {
          label: intl.formatMessage({
            description: 'br chat join',
            defaultMessage: 'joined the breakout room',
          }),
        },
        brLeave: {
          label: intl.formatMessage({
            description: 'br chat leave',
            defaultMessage: 'left the breakout room',
          }),
        },
      },
      messageInput: {
        emojiPicker: {
          title: intl.formatMessage({
            description: 'emoji picker title',
            defaultMessage: 'Pick your emoji...',
          }),
          i18n: {
            search: intl.formatMessage({
              description: 'emoji picker search',
              defaultMessage: 'Search',
            }),
            clear: intl.formatMessage({
              description: 'emoji picker clear',
              defaultMessage: 'Clear',
            }),
            notfound: intl.formatMessage({
              description: 'emoji picker not found',
              defaultMessage: 'No Emoji Found',
            }),
            skintext: intl.formatMessage({
              description: 'emoji picker skin text',
              defaultMessage: 'Choose your default skin tone',
            }),
            categories: {
              search: intl.formatMessage({
                description: 'emoji picker categories search',
                defaultMessage: 'Search Results',
              }),
              recent: intl.formatMessage({
                description: 'emoji picker categories recent',
                defaultMessage: 'Frequently Used',
              }),
              smileys: intl.formatMessage({
                description: 'emoji picker categories smileys',
                defaultMessage: 'Smileys & Emotion',
              }),
              people: intl.formatMessage({
                description: 'emoji picker categories people',
                defaultMessage: 'People & Body',
              }),
              nature: intl.formatMessage({
                description: 'emoji picker categories nature',
                defaultMessage: 'Animals & Nature',
              }),
              foods: intl.formatMessage({
                description: 'emoji picker categories foods',
                defaultMessage: 'Food & Drink',
              }),
              activity: intl.formatMessage({
                description: 'emoji picker categories activity',
                defaultMessage: 'Activity',
              }),
              places: intl.formatMessage({
                description: 'emoji picker categories places',
                defaultMessage: 'Travel & Places',
              }),
              objects: intl.formatMessage({
                description: 'emoji picker categories objects',
                defaultMessage: 'Objects',
              }),
              symbols: intl.formatMessage({
                description: 'emoji picker categories symbols',
                defaultMessage: 'Symbols',
              }),
              flags: intl.formatMessage({
                description: 'emoji picker categories flags',
                defaultMessage: 'Flags',
              }),
              custom: intl.formatMessage({
                description: 'emoji picker categories custom',
                defaultMessage: 'Custom',
              }),
            },
            categorieslabel: intl.formatMessage({
              description: 'emoji picker categories label',
              defaultMessage: 'Emoji categories',
            }),
            skintones: {
              1: intl.formatMessage({
                description: 'emoji picker default skin tone',
                defaultMessage: 'Default Skin Tone',
              }),
              2: intl.formatMessage({
                description: 'emoji picker light skin tone',
                defaultMessage: 'Light Skin Tone',
              }),
              3: intl.formatMessage({
                description: 'emoji picker medium-light skin tone',
                defaultMessage: 'Medium-Light Skin Tone',
              }),
              4: intl.formatMessage({
                description: 'emoji picker medium skin tone',
                defaultMessage: 'Medium Skin Tone',
              }),
              5: intl.formatMessage({
                description: 'emoji picker medium-dark skin tone',
                defaultMessage: 'Medium-Dark Skin Tone',
              }),
              6: intl.formatMessage({
                description: 'emoji picker dark skin tone',
                defaultMessage: 'Dark Skin Tone',
              }),
            },
          },
        },
        error: {
          label: intl.formatMessage({
            description: 'chat message input error',
            defaultMessage: 'Error, try again',
          }),
        },
      },
    }),
    tabKicked: (intl) => ({
      page: {
        title: {
          label: intl.formatMessage({
            description: 'tab kicked title text',
            defaultMessage: 'Currently Disabled',
          }),
        },
        message: {
          label: intl.formatMessage({
            description: 'tab kicked title text',
            defaultMessage:
              'Currently disabled. The host got you out of the room. In this modality, you are not allowed to interact with other participants in the room. Once you have left the room, you might still join again from the appointment saved in your Agenda.',
          }),
        },
      },
    }),
    tabTimeOut: (intl) => ({
      page: {
        title: {
          label: intl.formatMessage({
            description: 'tab timeout title text',
            defaultMessage: 'Time is up',
          }),
        },
      },
    }),
    bottomControls: (intl) => ({
      tooltips: {
        camera: {
          enable: {
            label: intl.formatMessage({
              description: 'enable camera tooltip text',
              defaultMessage: 'Enable Camera',
            }),
          },
          disable: {
            label: intl.formatMessage({
              description: 'disable camera tooltip text',
              defaultMessage: 'Disable Camera',
            }),
          },
        },
        microphone: {
          enable: {
            label: intl.formatMessage({
              description: 'enable microphone tooltip text',
              defaultMessage: 'Unmute',
            }),
          },
          disable: {
            label: intl.formatMessage({
              description: 'disable microphone tooltip text',
              defaultMessage: 'Mute',
            }),
          },
        },
        videoSharing: {
          enable: {
            label: intl.formatMessage({
              description: 'enable video sharing tooltip text',
              defaultMessage: 'Share Screen',
            }),
          },
          disable: {
            label: intl.formatMessage({
              description: 'disable video sharing tooltip text',
              defaultMessage: 'Stop Sharing',
            }),
          },
          someoneSharing: {
            label: intl.formatMessage({
              description: 'someone sharing tooltip text',
              defaultMessage:
                'You cannot share as long as another user shares the screen',
            }),
          },
        },
        exitCall: {
          label: intl.formatMessage({
            description: 'exit call tooltip text',
            defaultMessage: 'Exit',
          }),
        },
        raiseHand: {
          label: intl.formatMessage({
            description: 'raise hand tooltip text',
            defaultMessage: 'Raise Hand',
          }),
        },
      },
    }),
    layoutMenu: (intl) => ({
      menu: {
        tooltip: {
          label: intl.formatMessage({
            description: 'menu layout tooltip',
            defaultMessage: 'Change Layout',
          }),
        },
        title: {
          label: intl.formatMessage({
            description: 'menu layout title',
            defaultMessage: 'Change Layout',
          }),
        },
        options: {
          layout1: {
            label: intl.formatMessage({
              description: 'menu layout option layout1',
              defaultMessage: 'Tiled',
            }),
          },
          layout2: {
            label: intl.formatMessage({
              description: 'menu layout option layout2',
              defaultMessage: 'Spotlight',
            }),
          },
        },
      },
    }),
  },
};
